import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import {
  UAN_LOADING,
  UAN_SUCCESS,
  UAN_FAILED,
  FETCH_UAN_LOADING,
  FETCH_UAN_SUCCESS,
  FETCH_UAN_FAILED,
  ACCEPT_UAN_LOADING,
  ACCEPT_UAN_SUCCESS,
  ACCEPT_UAN_FAILED,
  UPLOAD_SALARY_LOADING,
  UPLOAD_SALARY_SUCCESS,
  UPLOAD_SALARY_FAILED,
  REMOVE_FILE_LOADING,
  REMOVE_FILE_SUCCESS,
  REMOVE_FILE_FAILED,
  UPDATE_UAN_LOADING,
  UPDATE_UAN_SUCCESS,
  UPDATE_UAN_FAILED,
  SAVE_UAN_LOADING,
  SAVE_UAN_SUCCESS,
  SAVE_UAN_FAILED,
  FETCH_GAP_LOADING,
  FETCH_GAP_SUCCESS,
  FETCH_GAP_FAILED,
  GAP_REASON_LOADING,
  GAP_REASON_SUCCESS,
  GAP_REASON_FAILED,
} from "../Constants/instantUanConstants";

import { handleApiError } from "../Helper/actionHelper";

export const getInstantUan = (callback=()=>{}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
      dispatch({ type: UAN_LOADING });
      const requestData = {
        token:
        userLocalData.id,
          "group": 22,
          "referenceNo": "1234567890"
      };
      
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/checkDetail",
        requestData,
        {
          headers: headers,
        } 
      );
  
      dispatch({
        type: UAN_SUCCESS,
        payload: data,
      });
      if(data?.status == 'success'){
        callback(data?.data);
      }
  
      handleApiError(data); //in case API return 200 with error details
    } catch (error) {
      dispatch({
        type: UAN_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

export const fetchUandetails = (candidate_id, initial_case_id, case_check_id, uanNo) => async (dispatch) => {
try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
    dispatch({ type: FETCH_UAN_LOADING });
    const requestData = {
    token:
    userLocalData.id,
        "initial_case_id": initial_case_id,
        "uanNumber": uanNo,
        "case_check_id":case_check_id,
        "candidate_id":candidate_id
    };
    
    const headers = {
    "Content-Type": "application/json",
    Username: "ibridge",
    Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
    "/CandidateApi/employmentViaUan",
    requestData,
    {
        headers: headers,
    } 
    );
    if(data && (data?.data?.manual == 1 || data?.code == 400)){
      toast.dismiss();
      toast.error(data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: FETCH_UAN_SUCCESS,
        payload: {},
      });
    }else{ 
      dispatch({
        type: FETCH_UAN_SUCCESS,
        payload: data,
      });
    }

    handleApiError(data); //in case API return 200 with error details
} catch (error) {
    dispatch({
    type: FETCH_UAN_FAILED,
    payload:
        error.response && error.response.data.message
        ? error.response
        : error.response,
    });
    handleApiError(error);
}
};

export const acceptUanEmployment = (uan_history_id,case_document_id,fatherName,callback=()=>{}) => async (dispatch) => {
    try {
        let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
        dispatch({ type: ACCEPT_UAN_LOADING });
        const requestData = {
        token:
        userLocalData.id,
            "uan_history_id": uan_history_id,
            "case_document_id":case_document_id,
            "father_name":fatherName
        };
        
        const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
        };
    
        const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/acceptEmploymentUanHistoryApi",
        requestData,
        {
            headers: headers,
        } 
        );
    
        dispatch({
        type: ACCEPT_UAN_SUCCESS,
        payload: data,
        });
        toast.dismiss();
        var msg= data?.message
        if(data?.code==400){
          toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }else{
          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          callback();
        }  
    
        handleApiError(data); //in case API return 200 with error details
    } catch (error) {
        dispatch({
        type: ACCEPT_UAN_FAILED,
        payload:
            error.response && error.response.data.message
            ? error.response
            : error.response,
        });
        handleApiError(error);
    }
    };

const errorMsg = "Please select the Document type First";

export const uploadSalarySlip =
(record, file, callback=()=>{}) =>
async (dispatch) => {
  try {
    
    dispatch({ type: UPLOAD_SALARY_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    record.token=userLocalData.id;

    console.log(record);

    let formData = new FormData();
    Object.keys(record).map((k) => {
      formData.set(k, record[k]);
    });
    for (let i = 0; i < record.uan_employment_proof.length; i++) {
      formData.append(`${"uan_employment_proof"}[${i}]`, record.uan_employment_proof[i]);
    }



    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/uploadFiles",
      formData,
      {
        headers,
      }
    );
    dispatch({
      type: UPLOAD_SALARY_SUCCESS,
      payload: data,
    });
    if (data) {
      const msg = "Uploaded Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      callback(data?.data);
    } else {
      alert("Invalid file");
    }

    // handleApiError(data);
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: UPLOAD_SALARY_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const removeFile =
  (record,callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: REMOVE_FILE_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      const requestData = {
        token: userLocalData.id,
        ...record,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/removeFiles",
        requestData,
        {
          headers,
        }
      );

      await dispatch({
        type: REMOVE_FILE_SUCCESS,
        payload: data,
      });
     
      const msg = "Removed Successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      callback();
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: REMOVE_FILE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

  export const updateUanEmployment =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPDATE_UAN_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
        token: userLocalData.id,
        ...record,
      };
      
      console.log(requestData);

      let formData = new FormData();
      Object.keys(requestData).map((k) => {
        formData.set(k, requestData[k]);
      });
      for (let i = 0; i < requestData.uan_employment_proof.length; i++) {
        formData.append(`${"uan_employment_proof"}[${i}]`, requestData.uan_employment_proof[i]);
      }
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      console.log(formData);
      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/updateEmploymentUanHistoryApi",
        // requestData,
        formData,
        {
          headers,
        }
      );

      await dispatch({
        type: UPDATE_UAN_SUCCESS,
        payload: data,
      });
     
      if(data?.code==400){
        var msg= data?.message
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }else{
        const msg = "Updated Successfully";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      callback(record, data);
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: UPDATE_UAN_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

  export const modifyUanEmployment =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPDATE_UAN_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
        token: userLocalData.id,
        ...record,
      };
      
      console.log(requestData);

      // let formData = new FormData();
      // Object.keys(requestData).map((k) => {
      //   formData.set(k, requestData[k]);
      // });
      // for (let i = 0; i < requestData.uan_employment_proof.length; i++) {
      //   formData.append(`${"uan_employment_proof"}[${i}]`, requestData.uan_employment_proof[i]);
      // }
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      // console.log(formData);
      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/updateEmploymentUanHistoryApi",
        requestData,
        // formData,
        {
          headers,
        }
      );

      await dispatch({
        type: UPDATE_UAN_SUCCESS,
        payload: data,
      });

      toast.dismiss();
      if(data?.code==400){
        var msg= data?.message
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }else{
        const msg = "Updated Successfully";
        toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } 
      callback(record,data);
      return data;
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: UPDATE_UAN_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

  export const saveUanEmployment =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: SAVE_UAN_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
        token: userLocalData.id,
        ...record,
      };
      
      console.log(requestData);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/saveCheckDetails",
        requestData,
        
        {
          headers,
        }
      );

      await dispatch({
        type: SAVE_UAN_SUCCESS,
        payload: data,
      });
      // toast.dismiss();
      if(data?.code==400){
        var msg= data?.message
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        callback(data?.data);
        return data;
      }
      else{
        var msg = "Updated Successfully";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        callback(data?.data);
        return data;
      }
      
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: SAVE_UAN_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

  export const fetchEmploymentGap =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: FETCH_GAP_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
        token: userLocalData.id,
        ...record,
      };
      
      console.log(requestData);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/gapUan",
        requestData,
        
        {
          headers,
        }
      );

      await dispatch({
        type: FETCH_GAP_SUCCESS,
        payload: data,
      });
     
      // const msg = "Employment Gaps Fetched";
      // const msg = data?.message;
      // toast.dismiss();
      // toast.success(msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });
      callback();
      return data;
      
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: FETCH_GAP_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };

  export const saveEmploymentGapReason =
  (record, callback=()=>{}) =>
  async (dispatch) => {
    try {
      dispatch({ type: GAP_REASON_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
        token: userLocalData.id,
        ...record,
      };
      
      console.log(requestData);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/saveGapReasonUan",
        requestData,
        
        {
          headers,
        }
      );

      await dispatch({
        type: GAP_REASON_SUCCESS,
        payload: data,
      });
      if(record?.gap_data?.length > 0){
        toast.dismiss();
       
        const msg = "Gaps Reason Saved";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      callback();
      return data;
      
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: GAP_REASON_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };